import { useUpdateHideHabitsAllTasksMutation } from 'shared/hooks/queries/use-update-hide-habits-all-tasks-mutation';

export const useUpdateHideHabitsAllTasks = () => {
  const { mutate } = useUpdateHideHabitsAllTasksMutation();

  return mutate;
};
